import { render, staticRenderFns } from "./NumberInputMinMax.vue?vue&type=template&id=0235c256&"
import script from "./NumberInputMinMax.vue?vue&type=script&lang=js&"
export * from "./NumberInputMinMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports